module.exports = __webpack_public_path__ + "img/askmebet-support.87fcf3f2.jpg";